import { Box, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import "../../../css/theatreTable.scss";
import { testSeatLayout } from "../../../utilities/sampleResponses";
import { vipRegex } from "../../../utilities/vipTest";
const TheatreTable = ({
  onSeatSelect,
  seat_data = testSeatLayout,
  screenImg,
  onSeatDeselect,
  seatMarkup,
  selectedSeats,
}) => {
  useEffect(() => {}, []);

  //ui controllers
  const handleSelectSeat = (event) => {
    if (!event.target.classList.contains("selectedSeat")) {
      event.target.classList.add("selectedSeat");
      onSeatSelect(
        event.target.getAttribute("seat"),
        parseInt(event.target.getAttribute("price")) + parseInt(seatMarkup),
        event.target.getAttribute("ticket_code"),
        event.target.getAttribute("description")
      );
    } else {
      event.target.classList.remove("selectedSeat");
      onSeatDeselect(event.target.getAttribute("seat"));
    }
  };

  return (
    <Stack className="container">
      <Typography
        variant="h6"
        fontFamily={"typold"}
        fontSize={{
          xs: "1rem",
          sm: "1.25rem",
        }}
      >
        Available seats
      </Typography>
      <Box sx={{ my: 1 }}>
        <Stack
          direction="row"
          sx={{
            flexWrap: "wrap",
            fontSize: {
              xs: "0.8rem",
              sm: "1rem",
            },
          }}
        >
          Regular:{" "}
          <Box
            className="seat key"
            sx={{ width: 20, height: 20, mx: 1, mb: 1 }}
          ></Box>
          VIP:{" "}
          <Box
            className="seat vip key"
            sx={{ width: 20, height: 20, mx: 1, mb: 1 }}
          ></Box>
          Walkway:{" "}
          <Box
            className="seat gap key"
            sx={{ width: 20, height: 20, mx: 1, mb: 1 }}
          ></Box>
          {/* Booked seat:{" "}
          <Box
            className="seat booked key"
            sx={{ width: 20, height: 20, mx: 1, mb: 1 }}
          ></Box>
          */}
          Reserved seat:{" "}
          <Box
            className="seat reserved key"
            sx={{ width: 20, height: 20, mx: 1, mb: 1 }}
          ></Box>
        </Stack>
      </Box>
      {Object.values(selectedSeats).length > 0 && (
        <>
          <Box
            sx={{
              mb: 1,
              fontSize: {
                xs: "0.8rem",
                sm: "1rem",
              },
            }}
          >
            Selected seats:{" "}
            {Object.values(selectedSeats).map((seat, index) => {
              return (
                <span key={seat.TicketCode + seat.SeatNumber}>
                  {seat.SeatNumber},
                </span>
              );
            })}
          </Box>
        </>
      )}
      <Stack
        sx={{
          width: { xs: "100%", sm: "70%" },
          position: "relative",
          height: "fit-content",

          justifyContent: "center",
        }}
      >
        <Box
          className="container-child"
          sx={{
            height: "fit-content",
            p: 1,
          }}
        >
          <Stack
            sx={{
              height: "90%",
              perspective: 1000,
            }}
          >
            <Box
              className="screen"
              sx={{
                backgroundImage: `linear-gradient(180deg, rgba(0,0,0,.5) 0,  rgba(0,0,0,.5) 100%), url(${screenImg})`,
              }}
            >
              Screen
            </Box>
            <Stack
              sx={{
                height: "100%",
                width: "100%",
                overflowX: "auto",
              }}
            >
              <table className="seatsContainer" spacing={1}>
                <tbody>
                  {seat_data.map((row) => {
                    let row_seats = row.RowLayout.split(",");
                    let row_prices = row.SeatPrice.split(",");
                    let row_ticketCodes = row.TicketCode.split(",");
                    let seatDescriptions = row.SeatDescription
                      ? row.SeatDescription.split(",")
                      : row_seats.map((seat) => "standard");
                    let currentSeat = 1;
                    const descriptions = row.SeatDescription?.split(",");
                    return (
                      <tr key={"row " + row.RowName}>
                        {row_seats.map((seat, index) => {
                          if (seat === "0") {
                            let seatName = row.RowName + currentSeat;

                            let vip = seatDescriptions[index].match(vipRegex);

                            currentSeat++;
                            return (
                              <td key={seatName}>
                                <button
                                  className={"seat ".concat(vip ? "vip" : "")}
                                  onClick={(event) => {
                                    handleSelectSeat(event);
                                  }}
                                  seat={seatName}
                                  price={parseInt(row_prices[index])}
                                  ticket_code={row_ticketCodes[index]}
                                  description={descriptions?.[index]}
                                >
                                  {seatName}
                                </button>
                              </td>
                            );
                          } else {
                            if (seat === "1") {
                              let seatName = row.RowName + currentSeat;

                              currentSeat++;
                              return (
                                <td key={seatName}>
                                  <button className="seat reserved"></button>
                                </td>
                              );
                            } else
                              return (
                                <td key={index}>
                                  <button className="seat gap"></button>
                                </td>
                              );
                          }
                        })}
                      </tr>
                    );
                  })}
                  {/* {seats.rows &&
                  seats.rows.map((row, index) => {
                    let rowName = alphabet[index];
                    let vip = seats.vipRows.indexOf(rowName) > -1;
                    return (
                      <tr key={"row " + index}>
                        {seats.seatsPerRow &&
                          seats.seatsPerRow.map((seat, index) => {
                            let seatName = rowName + (index + 1);
                            if (seat) {
                              let booked = false;
                              let reserved = false;
                              bookedSeats.forEach((bookedSeat) => {
                                if (bookedSeat === seatName) {
                                  booked = true;
                                }
                              });
                              reservedSeats.forEach((reservedSeat) => {
                                if (reservedSeat === seatName) {
                                  reserved = true;
                                }
                              });

                              if (booked)
                                return (
                                  <td key={seatName}>
                                    <button className="seat booked"></button>
                                  </td>
                                );
                              if (reserved)
                                return (
                                  <td key={seatName}>
                                    <button className="seat reserved"></button>
                                  </td>
                                );

                              return (
                                <td key={seatName}>
                                  <button
                                    className={"seat ".concat(vip ? "vip" : "")}
                                    onClick={handleSelectSeat}
                                    seat={seatName}
                                  >
                                    {seatName}
                                  </button>
                                </td>
                              );
                            } else {
                              return (
                                <td key={index}>
                                  <button className="seat gap"></button>
                                </td>
                              );
                            }
                          })}
                      </tr>
                    );
                  })} */}
                </tbody>
              </table>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
};
export default TheatreTable;
